import { lazy } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom"
import { RootState } from "../../../setup";
import { GetRedirect } from "./utils/Redirect";

export const AuthPage = () => {
    const user = useSelector((state: RootState) => state.auth.user, shallowEqual);
    const { path } = useRouteMatch();
    const Login = lazy(() => import('./features/Login'));
    const Register = lazy(() => import('./features/Register'));
    const PasswordRecovery = lazy(() => import('./features/PasswordRecovery'));
    
    return (
        <Switch>
            { !!user ? (
                <Redirect to={GetRedirect(user)}/>
            ) : (
                <>
                    <Route exact path={`${path}/login`} component={Login} />
                    <Route exact path={`${path}/register`} component={Register} />
                    <Route exact path={`${path}/forgot-password`} component={PasswordRecovery} />
                </>
            )}
        </Switch>
    )
}